import is from '../is';
import '../../util/a11y/inert';

/**
 * @param {boolean} state
 * @param {HTMLElement|HTMLElement[]} parent
 * @param {HTMLElement|HTMLElement[]} exception must be children of the parent (optional)
 */

export const setParentInert = (state, parent, exception) => {
  const setInert = child => {
    if (is.array(exception) || is.nodeList(exception)) {
      const match = exception.find(element => element === child);

      if (is.nullOrUndefined(match)) {
        child.inert = state;
      }
    } else if (is.element(exception) || is.empty(exception)) {
      if (child !== exception) {
        child.inert = state;
      }
    }
  }

  if (is.array(parent) || is.nodeList(parent)) {
    parent.forEach(element => {
      if (is.element(element) && element.children.length > 0) {
        Array.from(element.children).forEach(child => {
          setInert(child);
        });
      }
    });
  } else {
    if (is.element(parent) && parent.children.length > 0) {
      Array.from(parent.children).forEach(child => {
        setInert(child);
      });
    }
  }
}

/**
 * @param {boolean} state
 * @param {HTMLElement|HTMLElement[]} element
 */

export const setElementInert = (state, element) => {
  if (is.array(element) || is.nodeList(element)) {
    if (state === true) {
      element.forEach(el => {
        if (is.element(el)) {
          el.inert = true;
        }
      });
    } else {
      element.forEach(el => {
        if (is.element(el)) {
          el.inert = false;
        }
      });
    }
  } else if (is.element(element)) {
    if (state === true) {
      element.inert = true;
    } else {
      element.inert = false;
    }
  }
}

/**
 * Gets keyboard-focusable elements within a specified element
 * @param {HTMLElement} [element=document] element
 * @returns {Object}
 */
export const getKeyboardFocusableElements = (element = document) => {
  const focusable = element.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  const firstFocusable = focusable[0];
  const lastFocusable = focusable[focusable.length - 1];
  return {
    focusable,
    firstFocusable,
    lastFocusable,
  };
}


export const trapElement = (...elements) => {
  const excluded = [];
  let firstElement;
  let lastElement;
  let keydownListener;

  elements.forEach((element, index) => {
    if (index === 0) {
      const focusableElements = getAllFocusableElements(element);
      firstElement = focusableElements.length === 0 ? element : focusableElements[0];
    } else if (index === elements.length - 1) {
      const focusableElements = getAllFocusableElements(element);
      lastElement = focusableElements.length === 0 ? element : focusableElements[focusableElements.length - 1];
    }
    const roots = getRoots(element).filter(element => excluded.indexOf(element) === -1);
    excluded.push(...roots);
  });

  const siblings = [];

  const hideSiblingsAccessibility = element => {
    const children = Array.from(element.children);
    children.forEach(child => {
      if (excluded.indexOf(child) !== -1) {
        if (elements.indexOf(child) === -1) {
          hideSiblingsAccessibility(child);
        }
      } else {
        const inert = child.inert;
        siblings.push({ element: child, inert });
        child.inert = true;
      }
    })
  };

  hideSiblingsAccessibility(document.body);
  elements.forEach(element => {
    element.inert = false;
    element.setAttribute('aria-hidden', false); // ??
  });

  if (firstElement && lastElement) {
    keydownListener = e => {
      const { target, key, shiftKey } = e;
      if (key === 'Tab') {
          if (!shiftKey && target === lastElement) {
              e.preventDefault();
              firstElement.focus();
          } else if (shiftKey && target === firstElement) {
              e.preventDefault();
              lastElement.focus();
          }
      }
    }
    window.addEventListener('keydown', keydownListener);
  }

  return () => {
    siblings.forEach(sibling => {
      if (sibling.inert === null) {
        sibling.element.inert = false;
      } else {
        sibling.element.inert = sibling.inert;
      }
    });
    if (keydownListener) window.removeEventListener('keydown', keydownListener);
  };
}

// utils
const getRoots = (element) => {
  const roots = [];
  let parent = element.parentElement;
  while (parent.tagName !== 'BODY') {
    roots.push(parent);
    parent = parent.parentElement;
  }

  return roots;
}

const getAllFocusableElements = (element) => {
  return element.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/util/a11y/handle-inert.js